// @flow

import React, { type Node, useMemo } from 'react';
import { ValidationContext } from './context';
import { type UserInputValidationErrors } from './types';
import { type PlaceOrderErrorPayload } from '@tectonics/prs/outgoing-payment';

type Props = {|
  +userInputValidationErrors: UserInputValidationErrors,
  +submitError: ?PlaceOrderErrorPayload,
  +children: Node,
|};

export function ValidationProvider({ userInputValidationErrors, submitError, children }: Props): Node {
  const validation = useMemo(() => {
    return {
      userInputValidationErrors,
      submitError,
    };
  }, [userInputValidationErrors, submitError]);

  return (
    <ValidationContext.Provider value={validation}>
      {children}
    </ValidationContext.Provider>
  );
}
